<template>
    <v-layout column class="create-feature-event" mb-3>
        <status-bar :action="addPostAction"></status-bar>
        <v-layout column class="white_background relative-position">
            <div v-if="!! imageUrl" class="create-feature-event__background">
                <v-img :src=" imageUrl" :class="newFeatureEvent.isImageOverLay ? 'create-feature-event__background-overlay': 'create-feature-event__background-img'"></v-img>
            </div>
           
            <v-flex xs12 class="create-feature-event__item-form">
                <v-form v-model="fieldsValid">
                    <v-text-field id="feature_item_link"
                                  :class="!!imageUrl ? 'item-detail' : 'detail-placeholder'"
                                  :name="communityCommonConstant.featureEvent.LINK_URL"
                                  :rules="urlRules"
                                  data-qe-id="feature-event_url-link_input"
                                  v-model="newFeatureEvent.url"
                                  :placeholder="communityCommonConstant.featureEvent.LINK_PLACEHOLDER"
                                  autofocus
                                  :disabled="isSubmitting"
                                  >
                    </v-text-field>
                    <v-text-field id="feature_item_title"
                                  :class="!!imageUrl ? 'item-detail' : 'detail-placeholder'"
                                  :name="communityCommonConstant.featureEvent.TITLE"                                 
                                  v-model="newFeatureEvent.title"
                                  :disabled="isSubmitting"
                                  data-qe-id="feature-event_title_input"
                                  :placeholder="communityCommonConstant.featureEvent.TITLE"                                 
                                   maxlength="55">
                    </v-text-field>
                    <v-text-field id="feature_item_subtitle"
                                  :class="!!imageUrl ? 'item-detail' : 'detail-placeholder'"
                                  :name="communityCommonConstant.featureEvent.SUB_TITLE"
                                  v-model="newFeatureEvent.subtitle"
                                  data-qe-id="feature-event_sub-title_input"
                                  :placeholder="communityCommonConstant.featureEvent.SUB_TITLE"
                                  :disabled="isSubmitting" maxlength="55">
                    </v-text-field>
                    <v-textarea id="feature_item_description"
                                height="150"
                                :class="!!imageUrl ? 'item-detail' : 'detail-placeholder'"
                                :name="communityCommonConstant.featureEvent.DESCRIPTION"                                
                                :placeholder="communityCommonConstant.featureEvent.DESCRIPTION"
                                v-model="newFeatureEvent.body"
                                data-qe-id="feature-event_body_input"
                                :disabled="isSubmitting"
                               >
                    </v-textarea>
                </v-form>
            </v-flex>
           
        </v-layout>
        <v-flex text-left class="white_background create-feature-event__dimensions">
                    {{communityCommonConstant.featureEvent.REQUIRED_TO_SAVE_TEXT}} <span v-html=communityCommonConstant.featureEvent.OPTIONAL_DIMENSION></span>
            </v-flex>
        <v-card-actions class="white_background create-feature-event__actions">
            <v-layout row wrap>
                <v-flex class="text-left small create-feature-event__photo-handler">
                    <file-upload
                            v-if="!imageUrl"
                            class="create-feature-event__file-upload secondary_btn"
                            extensions="gif,jpg,jpeg,png,webp"
                            accept="image/png, image/gif, image/jpeg"
                            color="info"
                            post-action="/upload/post"
                            data-qe-id="feature-event_file-uploader"
                            v-model="files"
                            @input="updateUploadedFile"
                            @input-filter="inputFilterForImageFile"
                            ref="upload">
                        <span class="create-feature-event__photo-button_title">{{communityCommonConstant.featureEvent.ADD_PHOTO}}</span>
                        <v-icon size="20" color="ypo_blue">photo</v-icon>
                    </file-upload>
                <v-flex v-else d-flex>
                <v-btn class="create-feature-event__photo-button secondary_btn"
                       data-qe-id="feature-event_remove_image_btn"
                       @click="removePostImage">
                    <span class="create-feature-event__photo-button_title">{{communityCommonConstant.featureEvent.REMOVE_PHOTO}}</span>
                    <v-icon size="20" color="ypo_blue">clear</v-icon>
                </v-btn>
                 <v-checkbox class="darken-image" data-qe-id="feature-event_darken-image"
                                    v-model="newFeatureEvent.isImageOverLay"
                                    color="ypo_blue"
                                    :label="communityCommonConstant.featureEvent.DARKEN_IMAGE"
                                    hide-details>
                                </v-checkbox>  
                </v-flex>
            </v-flex>
            <v-flex>
                <v-flex text-right class="create-feature-event__actions__btns">
                <v-btn class="create-feature-event__cancel_btn"
                       flat
                       id="feature_item_cancel"
                       :disabled="isSubmitting"
                       data-qe-id="feature-event_cancel_btn"
                       @click.native="cancelItem()">
                    {{appCommonConstants.CANCEL}}
                </v-btn>
                <v-btn class="create-feature-event__save_btn"
                       color="primary"
                       id="feature_item_save"
                       data-qe-id="feature-event_save_btn"
                       :disabled="!formValid || isSubmitting"
                       @click.native="saveItem()">
                    {{appCommonConstants.SAVE}}
                </v-btn>
            </v-flex>
            </v-flex>
            </v-layout>
        </v-card-actions>
    </v-layout>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    import { communityCommonConstant } from "../communityCommon.constant";
    import { appCommonConstants } from "../../appCommon.constants";
    import { getUploadedFileBase64, inputFilterForImageFile } from '../../../common/utils/fileUploader';
    import FileUpload from 'vue-upload-component';
    import { storeAction } from "../../../store/storeActions.constant";
    import StatusBar from "../../StatusBar/StatusBar";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { validateUrl } from "@/common/utils/utils";

    export default {
        name: 'CreateFeatureEvent',
        components: {
            StatusBar,
            FileUpload,
        },
        props: {
            featureEventObject: {
                type: Object,
                required: true,
            },
            changeComponent: {
                type: Function,
            },
            itemCount: {
                type: Number,
            },
            returnOnSave: {
                type: String,
            },
        },
        data() {
            return {
                communityCommonConstant,
                appCommonConstants,
                newFeatureEvent: {
                    ...this.featureEventObject,
                },
                fieldsValid: false,
                isSubmitting: false,
                files: [],
                urlRules: [
                    v => !v || validateUrl(v) || communityCommonConstant.featureEvent.errors.SLD_IS_REQUIRED,
                ],
            };
        },
        methods: {
            ...mapActions({
               saveFeatureEvent: `chapter/${storeAction.createFeatureEvent}`,
            }),
            ...mapMutations({
                removeFeatureItemInEdit: `chapter/${storeMutation.updateFeatureEventInEdit}`,
            }),
            inputFilterForImageFile,
            removePostImage() {
                this.newFeatureEvent.featuredPostImage = {};//Object.assign({}, this.newFeatureEvent.featuredPostImage);
                this.newFeatureEvent.preserveExistngFeaturedPostImage = false;
                this.files = [];
            },
            updateUploadedFile() {               
                this.newFeatureEvent.featuredPostImage = {
                    ...this.newFeatureEvent.featuredPostImage,
                    url: this.files[0].url,
                };
                const { file } = this.files[0];
                this.newFeatureEvent.preserveExistngFeaturedPostImage = false;
                getUploadedFileBase64(file).then((customJsonFile) => {
                    //customJsonFile is your newly constructed file.
                    if (customJsonFile) {
                        this.newFeatureEvent.featuredPostImage = {
                            data: customJsonFile.base64StringFile,
                            contentType: customJsonFile.fileType,
                        };
                    } else {
                        throw new Error('File not loaded.');
                    }
                });
            },
            cancelItem() {
                this.newFeatureEvent = {
                    ...this.featureEventObject,
                };
                this.removeFeatureItemInEdit(null);
                // eslint-disable-next-line no-nested-ternary
                this.changeComponent(this.returnOnSave ? this.returnOnSave
                    : this.itemCount > 0
                        ? communityCommonConstant.featureEvent.componentNames.featureEventList
                        : communityCommonConstant.featureEvent.componentNames.manageFeatureEvent);
            },
            saveItem() {
                this.isSubmitting = true;
                this.newFeatureEvent = this.newFeatureEvent.id
                    ? {
                        ...this.newFeatureEvent,
                    }
                    : {
                        ...this.newFeatureEvent,
                        order: this.itemCount + 1,
                    };

                this.saveFeatureEvent(this.newFeatureEvent)
                    .then(() => {
                        this.isSubmitting = true;
                        this.removeFeatureItemInEdit(null);
                        this.changeComponent(this.returnOnSave ? this.returnOnSave : communityCommonConstant.featureEvent.componentNames.featureEventList);
                    })
                    .catch(() => {
                        this.isSubmitting = false;
                    });
            },
        },
        computed: {
             ...mapState('actionState', ['actions']),
            addPostAction() {
                return this.actions[storeAction.createFeatureEvent];
            },
            imageUrl() {
                /*eslint-disable-next-line no-nested-ternary*/
                return this.files.length && this.files[0].url
                    ? this.files[0].url
                    : this.newFeatureEvent.featuredPostImage && this.newFeatureEvent.featuredPostImage.url
                        ? this.newFeatureEvent.featuredPostImage.url
                        : null;
            },           
             formValid() {
                    return this.fieldsValid && ((this.files && this.files.length > 0) || (this.newFeatureEvent.featuredPostImage && this.newFeatureEvent.featuredPostImage.url)) && this.newFeatureEvent.url; 
            },
        },
    };
</script>

<style lang="scss">

    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';
    @import '../../../common/styles/_responsive.scss';

    .create-feature-event {
        border: 1px solid $ypo-medium-gray;
        background-color: $ypo-cta;
        border-radius: 4px;
        padding: 10px 1px 1px 1px;

        &__file-upload {
            padding: 8px 14px;

            * {
                cursor: pointer !important;
            }

            &:hover {
                background-color: $ypo-open-blue-gray !important;
            }
        }
        &__dimensions {
            color: $ypo-blue;
            padding: 5px 14px 0;
        }
        
        .v-card__actions {
            padding: 20px 16px 13px !important;
        }

        .v-input {
            margin-top: 0 !important;
            padding-top: 7px !important;
            .v-label {
                font-size: 14px;
                font-weight: 500;
            }
        }

        &__title {
            background-color: $ypo-cta;
        }

        &__photo-button {
            padding: 8px 14px;
            max-width: 150px;
            height: 36px;

            &_title {
                color: $ypo-blue;
                font-weight: 600;
                padding-right: 5px;
                text-transform: capitalize;
            }
        }

        &__photo-handler {
            z-index: 2;
            .darken-image {
                margin-left: 22px;
            }
        }

        &__background {
            position: absolute;
            z-index: 1;
            height: 100%;
            width: 100%;
            &-img {
                height: 100%;
                width: 100%;
            }
            &-overlay {
                height: 100%;
                width: 100%;
                &:after {
                content: "";
                position: absolute;
                opacity: .5;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 3;
                background: $black;
            }
            }
            
        }

        &__item-form {
            z-index: 2;
            padding: 24px 8px 8px 8px;
        }

        &__cancel_btn {
            border-radius: 4px;
            font-weight: 600;
            font-size: 15.44px;
            letter-spacing: 1.25px;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            line-height: 16px;
        }

        &__save_btn {
            border-radius: 4px;
            background-color: $ypo-blue !important;
            font-family: Gentona, Arial, Helvetica, sans-serif !important;
            font-size: 14.44px;
            font-weight: 600;
            letter-spacing: 1.25px;
        }

        .item-detail {
            color: $white !important;

            ::placeholder {
                color: $white !important;
                font-style: italic;
                opacity: 1;
            }

            :-ms-input-placeholder {
                color: $white !important;
                font-style: italic;
            }

            ::-ms-input-placeholder {
                color: $white !important;
                font-style: italic;
            }

            input {
                color: $white !important;
            }

            textarea {
                color: $white !important;
            }
        }

        .detail-placeholder {

            ::placeholder {
                font-style: italic;
            }

            :-ms-input-placeholder {
                font-style: italic;
            }

            ::-ms-input-placeholder {
                font-style: italic;
            }
        }

        #feature_item_description {
            min-height: 120px;
            max-height: 120px;
        }
        @include breakpoint(xs) {
            &__photo-button {
                max-width: 140px;
                margin-bottom: 30px !important;
            }
            &__cancel_btn {
                font-size: 12px;
                padding: 0;
            }
            &__save_btn {
                margin-left: 0 !important;
            }
            .v-input {
                font-size: 13px;
            }
        }
    }
</style>
